import { render, staticRenderFns } from "./ToMeCustomer.vue?vue&type=template&id=e8370956&"
import script from "./ToMeCustomer.vue?vue&type=script&lang=ts&"
export * from "./ToMeCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports